module.exports = __webpack_public_path__ + "static/media/catalouge-download.fad98c09.svg";